__turbopack_context__.v({
  "image": "ProductCard-module-scss-module__vAdMka__image",
  "name": "ProductCard-module-scss-module__vAdMka__name",
  "originalPrice": "ProductCard-module-scss-module__vAdMka__originalPrice",
  "price": "ProductCard-module-scss-module__vAdMka__price",
  "productCard": "ProductCard-module-scss-module__vAdMka__productCard",
  "ratings": "ProductCard-module-scss-module__vAdMka__ratings",
  "reviewTotal": "ProductCard-module-scss-module__vAdMka__reviewTotal",
  "salePrice": "ProductCard-module-scss-module__vAdMka__salePrice",
});
